var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating2Pressed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37C28.9411 37 37 28.9411 37 19C37 9.05888 28.9411 1 19 1C9.05888 1 1 9.05888 1 19C1 28.9411 9.05888 37 19 37Z",
    fill: "#FFF7AE",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8721 27.804C22.3761 22.904 15.3761 22.904 12.8801 27.804Z",
    fill: "#FFF7AE",
    fillOpacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8721 27.804C22.3761 22.904 15.3761 22.904 12.8801 27.804M37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19Z",
    stroke: "#006D5B",
    strokeWidth: 0.857143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 19C28.1941 19 29 18.1941 29 17.2C29 16.2059 28.1941 15.4 27.2 15.4C26.2059 15.4 25.4 16.2059 25.4 17.2C25.4 18.1941 26.2059 19 27.2 19Z",
    fill: "#006D5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 19C11.7941 19 12.6 18.1941 12.6 17.2C12.6 16.2059 11.7941 15.4 10.8 15.4C9.80589 15.4 9 16.2059 9 17.2C9 18.1941 9.80589 19 10.8 19Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating2Pressed);
export default __webpack_public_path__ + "static/media/rating-2-pressed.6401137213e170906494a2df07053add.svg";
export { ForwardRef as ReactComponent };